import { useRef } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import SearchBar from '@components/searchBar';
import { TextBold } from '@components/typography';
import styles from './styles.module.css';

import Export from '@pages/AuditTrailSellOut/components/export';
import FilterButton from '@pages/AuditTrailSellOut/components/filter/filterButton';
import FilterList from '@pages/AuditTrailSellOut/components/filter/filterList';
import Resync from '@pages/AuditTrailSellOut/components/resync';

import { useFilter } from '@pages/AuditTrailSellOut/state/filters';

const Filter = () => {
    const { isOpen: isOpenFilter, onClose: onCloseFilter, onOpen: onOpenFilter } = useDisclosure();

    const filters = useFilter();
    const debounceTimer = useRef(null);

    const onChangeSearch = (e) => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        debounceTimer.current = setTimeout(() => {
            filters.setFilter({ page: 1, searchQuery: e.target.value });
        }, 150);
    };

    return (
        <>
            <TextBold className={styles.title}>Audit Trail - Sellout</TextBold>

            <Box className={styles.head}>
                <Flex justify="space-between">
                    <Flex gap="24px">
                        <SearchBar placeholder="Cari nama customer atau ID" onChange={onChangeSearch} />
                        <FilterButton isOpen={isOpenFilter} onClose={onCloseFilter} onOpen={onOpenFilter} />
                        <Export />
                    </Flex>
                    {/* <Resync /> */}
                </Flex>
                <FilterList isOpen={isOpenFilter} onClose={onCloseFilter} onOpen={onOpenFilter} />
            </Box>
        </>
    );
};

export default Filter;
